// ISO 3166-1[2] - Alpha-2 code
export enum REGIONS {
    US = 'US',
    EMEA = 'EMEA'
}
